(function(){
  function init(){
    var bar=document.getElementById('lhe-sticky');
    var hero=document.querySelector('.lhe-hero');
    var sign=document.getElementById('exhale-signup');
    if(!bar||!hero||bar.dataset.ready==='1')return;
    bar.dataset.ready='1';
    var ticking=false, shown=null;
    var check=function(){
      ticking=false;
      var vh=window.innerHeight||0;
      var past=hero.getBoundingClientRect().bottom<=40;
      var over=false;
      if(sign){var r=sign.getBoundingClientRect();over=(r.top<vh && r.bottom>0);}
      var show=past&&!over;
      if(show!==shown){
        shown=show;
        bar.classList.toggle('is-up',show);
        bar.setAttribute('aria-hidden',show?'false':'true');
      }
    };
    var onScroll=function(){ if(!ticking){ ticking = true; requestAnimationFrame(check); } };
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
    bar.lheCheck=check;
    check();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',function(){ var b=document.getElementById('lhe-sticky'); if(b){b.dataset.ready='';} init(); });
})();